import React, { useEffect } from "react";
import { ForgotPasswordSchema } from "../../../components/Helpers";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  requestForgotPassword,
  setResetForgotPassword,
} from "../../../Redux/LoginState/LoginActionCreator";
import FormField from "../../../components/FormField";
import Uni_Logo from "../../../Assets/newlogo.jpeg";
import FormButton from "../../../components/FormButton";

function ForgotPasswordForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ForgetPasswordState = useSelector(
    (state) => state.ForgotPasswordReducer
  );

  const forgotPassword = (values) => {
    dispatch(requestForgotPassword(values));
  };

  useEffect(() => {
    dispatch(setResetForgotPassword());
  }, []);

  useEffect(() => {
    if (ForgetPasswordState?.response && !ForgetPasswordState?.loading) {
      toast.success("Email Sent Successful");
    }
    if (ForgetPasswordState?.error && !ForgetPasswordState?.loading) {
      toast.error(ForgetPasswordState?.error?.message || ForgetPasswordState?.error || "Something went wrong");
      // dispatch(setResetForgotPassword());
    }
  }, [ForgetPasswordState]);

  useEffect(() => {
    return () => {
      dispatch(setResetForgotPassword());
    };
  }, []);

  return (
    <div className="w-full">
      {!ForgetPasswordState?.response ? (
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={ForgotPasswordSchema}
          onSubmit={(values) => {
            forgotPassword(values);
          }}
        >
          {({ errors, touched, values, handleChange }) => (
            <Form className="space-y-6">
              {/* Logo */}
              <div className="flex justify-center mb-6">
                <img 
                  src={Uni_Logo} 
                  alt="Logo" 
                  className="w-32 h-auto transform hover:scale-105 transition-transform duration-300" 
                />
              </div>

              {/* Form Fields */}
              <div className="space-y-4">
                <FormField
                  label="Email"
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  error={errors.email}
                  touched={touched.email}
                  required
                  className="bg-white/5 border-gray-600 text-black placeholder-gray-400 focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-200"
                />
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 justify-end">
                <FormButton
                  type="button"
                  className="bg-primary hover:bg-primaryDark text-white font-medium py-3 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200"
                  onClick={() => navigate('/login')}
                >
                  Back to Sign In
                </FormButton>
                <FormButton
                  type="submit"
                  className="bg-primary hover:bg-primaryDark text-white font-medium py-3 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200"
                >
                  Submit
                </FormButton>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <div className="text-center py-8">
          <div className="mb-6">
            <img 
              src={Uni_Logo} 
              alt="Logo" 
              className="w-32 h-auto mx-auto transform hover:scale-105 transition-transform duration-300" 
            />
          </div>
          <div className="bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/20">
            <p className="mb-4 text-gray-700">Email has been sent to your registered email address</p>
            <FormButton
              type="button"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary hover:bg-primaryDark text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200"
              onClick={() => navigate('/login')}
            >
              Sign In Here
            </FormButton>
          </div>
        </div>
      )}
    </div>
  );
}

export default ForgotPasswordForm;
